import { Injectable } from '@angular/core';
import { InlineAddConfig } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class StockLocationAddConfigService {
  getStockLocationConfig(): InlineAddConfig {
    return {
      modelType: 'stocklocation',
      title: 'Stock Location',
      apiEndpoint: 'api/stocklocations/create',
      hiddenData: {
        isActive: true,
      },
      fields: [
        {
          name: 'code',
          label: 'Stock Location Code',
          type: 'text',
          required: true,
          isInstantData: true,
          maxLength: 50,
          placeholder: 'Auto-generated by system',
          size: 'half'
        },
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: true,
          maxLength: 250,
          placeholder: 'Enter location name',
          size: 'half'
        },
        
      ],
      selectionConfig: {
        targetField: 'stockLocationId',
        valueField: 'id',
        labelField: 'code'
      }
    };
  }
}
